/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputSiblingFrequencyStatus
 */
export interface OutputSiblingFrequencyStatus {
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingFrequencyStatus
     */
    band: string;
    /**
     * 
     * @type {number}
     * @memberof OutputSiblingFrequencyStatus
     */
    cause: number;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingFrequencyStatus
     */
    channel: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingFrequencyStatus
     */
    directionPoint?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingFrequencyStatus
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingFrequencyStatus
     */
    side: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingFrequencyStatus
     */
    teamName: string;
    /**
     * 
     * @type {string}
     * @memberof OutputSiblingFrequencyStatus
     */
    zoneName: string;
}

/**
 * Check if a given object implements the OutputSiblingFrequencyStatus interface.
 */
export function instanceOfOutputSiblingFrequencyStatus(value: object): boolean {
    if (!('band' in value)) return false;
    if (!('cause' in value)) return false;
    if (!('channel' in value)) return false;
    if (!('reason' in value)) return false;
    if (!('side' in value)) return false;
    if (!('teamName' in value)) return false;
    if (!('zoneName' in value)) return false;
    return true;
}

export function OutputSiblingFrequencyStatusFromJSON(json: any): OutputSiblingFrequencyStatus {
    return OutputSiblingFrequencyStatusFromJSONTyped(json, false);
}

export function OutputSiblingFrequencyStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputSiblingFrequencyStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'],
        'cause': json['cause'],
        'channel': json['channel'],
        'directionPoint': json['directionPoint'] == null ? undefined : json['directionPoint'],
        'reason': json['reason'],
        'side': json['side'],
        'teamName': json['teamName'],
        'zoneName': json['zoneName'],
    };
}

export function OutputSiblingFrequencyStatusToJSON(value?: OutputSiblingFrequencyStatus | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'cause': value['cause'],
        'channel': value['channel'],
        'directionPoint': value['directionPoint'],
        'reason': value['reason'],
        'side': value['side'],
        'teamName': value['teamName'],
        'zoneName': value['zoneName'],
    };
}

